module.exports = __webpack_public_path__ + "img/938.e39e17ed.jpg";